<template>
  <div class="container" :class="{ 'is-framed': framed }">
    <div class="entity-header">
      <div>
        <button class="button-icon square-icon floatright" href="#" :title="$t('tournament.deleteTournament')"  v-if="userIsTournamentManager" @click="preDeleteTournament"><font-awesome-icon icon="trash" /></button>
        <button class="button-icon square-icon floatright" href="#" :title="$t('tournament.editTournament')" v-if="userIsTournamentManager" @click="editTournament"><font-awesome-icon icon="cog" /></button>
        <button class="button-icon square-icon floatright" href="#" :title="$t('tournament.createStaticSite')" v-if="userIsTournamentManager" @click="createStaticFiles"><font-awesome-icon icon="cloud-upload-alt" /></button>
      </div>

      <div class="entity-title">{{ tournament.name }} {{ tournament.edition }}</div>
      <div class="entity-details" v-if="userIsTournamentManager">{{ $t('tournament.youAreManager') }}</div>
      <div class="entity-details" v-if="userIsTournamentParticipant">{{ $t('tournament.youAreParticipant') }}</div>
      <div class="entity-details">{{ tournament.location }}</div>
      <div class="entity-details">{{ showTournamentDate() }}</div>

      <div class="tab-nav">
        <div @click.prevent="setActiveTab('Registrations')" class="tab" :class="{ active: isActiveTab('Registrations') }">{{ $t('tournaments.registrations') }}</div> 
        <div @click.prevent="setActiveTab('Rounds')" class="tab" :class="{ active: isActiveTab('Rounds') }">{{ $t('tournaments.rounds') }}</div> 
        <div @click.prevent="setActiveTab('Results')" class="tab" :class="{ active: isActiveTab('Results') }">{{ $t('tournaments.results') }}</div> 
      </div>
    </div>

    <modal v-on:cancel="handleModalResultCancel()" 
           v-on:ok="handleModalResultOK()" 
           v-if="showModal" v-bind:modalText="modalText"></modal>    

    <transition name="modal-fade" v-if="showUploadStaticFiles">
      <div class="modal-backdrop">
        <div class="modal">
          <section class="modal-body">
            <slot name="body">
              <UploadStaticFilesModal v-on:cancel="handleUploadModalResultCancel()"
                                      v-on:ok="handleUploadModalResultOK()"></UploadStaticFilesModal>
            </slot>
          </section>
        </div>
      </div>
    </transition>

    <section v-if="isActiveTab('Registrations')"> 
      <registrations-list :tournamentId="$route.params.tournamentId"
                          :managementFunctions="userIsTournamentManager"></registrations-list>
    </section>

    <section v-show="isActiveTab('Rounds')"> 
      <rounds-list ref="RoundsList" :tournamentId="$route.params.tournamentId"
                v-on:showRound="showRoundResults($event)"
                :managementFunctions="userIsTournamentManager"></rounds-list>
    </section>

    <section v-if="isActiveTab('Results')"> 
      <results :tournamentId="$route.params.tournamentId" 
               :roundNumber="-1"
               :managementFunctions="userIsTournamentManager"></results>
    </section>

    <div class="bar footer" v-if="framed">
      <div class="version">        
        <router-link to="/" class="bar-item" target="_blank"><img src="../../assets/img/CA_Logo_black.png" alt="Chess Administrator" class="logo-header"></router-link>
        happily served by Chess Administrator, <router-link to="/info/version" class="footerLink specialLink"> version: 1.0.1 </router-link>
      </div>
    </div> 
  </div>
</template> 

<script>
import RegistrationsList from "@/components/tournaments/registrations/RegistrationsList";
import RoundsList from "@/components/tournaments/rounds/RoundsList";
import Results from "@/components/tournaments/results/Results";
import {RestAPI} from "@aws-amplify/api-rest";
import moment from 'moment';
import Modal from "@/components/Modal";
import UploadStaticFilesModal from '@/components/tournaments/UploadStaticFilesModal';

const apiName = 'api';
const path = '/tournament/';
const myInit = { 
  response: false,
};

export default {
  name: 'Tournament',
  components: {Modal, RegistrationsList, Results, RoundsList, UploadStaticFilesModal},
  data: function () {
    return {
      activeTabItem: "Results",
      activeRound: "1", 
      currentPlayerImportStatus: "",
      modalText: "",
      rounds: [],
      roundCountPlusOne: -1,
      showingModal: false,
      showingUploadStaticFiles: false,
      tournament: {tournamentId: this.tournamentId, timeControl: {periods: []}, managers: []},
      thisUserIsTournamentManager: false
    }
  },
  activated() {
    console.log('Activated');
  },
  beforeMount() {
    this.loadTournament();
  },
  mounted() {
    if (this.$route.query.registrationlist == "yes")
      this.setActiveTab('Registrations');
  },
  computed: {
    getActiveRound() {
      return this.activeRound;
    },
    framed: function () { // is this component showing in an iFrame
      return this.$route.query.framed == "yes";
    },
    showModal() {        // Is a modal component showing over this component?
      return this.showingModal;
    },
    showUploadStaticFiles() {
      return this.showingUploadStaticFiles;
    },
    userIsTournamentManager() {
      console.log("userIsTournamentManager request");
      return this.thisUserIsTournamentManager;
    },
    userIsTournamentParticipant() {
      console.log("heb ik personen? :" + this.tournament.managers.length);
      return false;  // TODO
    },
  },
  methods: {
    createStaticFiles() {
      this.showingUploadStaticFiles = true;
    },

    deleteTournament() {
      let completePath = path + this.$route.params.tournamentId
      const localInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        response: false,
      };
      console.log('delete path: ' + completePath);
      RestAPI
        .del(apiName, completePath, localInit)
        .then(response => {
          console.log(response);
        })
        .catch(error => {
          if (error.status !== 404) {
            console.log("ERROR", JSON.stringify(error));
          }
        });
      this.$router.push("/tournaments/");
    },

    determineTournamentManagement() {
      if (this.tournament.managers.length > 0) {
        var persons = this.tournament.managers.filter((item) => {
              return (item.personId == this.$CAUser.getPersonId());
          });
        console.log("person is manager: " + JSON.stringify(persons));
        this.thisUserIsTournamentManager = (persons.length == 1);      
      } 
    },

    editTournament() {
      this.$router.push({name: 'EditTournamentDetails', params: {tournamentId: this.tournament.tournamentId}, query: {mode: 'edit'}})
    },

    isActiveTab (tabItem) {
      return this.activeTabItem === tabItem;
    },

    getRoundCountPlusOne() {
      if (this.roundCountPlusOne == -1) {
        let path = '/tournament/' + this.tournamentId + '/round' ;
        let that = this
        RestAPI
          .get(apiName, path, myInit)
          .then(response => {
            that.rounds = response;
            that.roundCountPlusOne = that.rounds.length + 1;
            console.log(that.roundCountPlusOne);
          })
          .catch(error => {
            console.log(error.response);
          });
      }

      return this.roundCountPlusOne;
    },

    handleModalResultCancel() {
      console.log('Action cancelled');
      this.showingModal = false;
    },

    handleModalResultOK() {
      console.log('Action ok-d');
      this.showingModal = false;
      this.deleteTournament();
    },

    handleUploadModalResultCancel() {
      console.log('Action cancelled');
      this.showingUploadStaticFiles = false;
    },

    handleUploadModalResultOK() {
      console.log('Action ok-d. ');
      this.showingUploadStaticFiles = false;
    },

    loadTournament() {
      let that = this
      let completePath = path + this.$route.params.tournamentId
      RestAPI
        .get(apiName, completePath, myInit)
        .then(response => {
          that.tournament = response;
          this.$CA_Storage.setVisit("tournament", this.$route.params.tournamentId, that.tournament.name);
          this.determineTournamentManagement();
          })
        .catch(error => {
          if (error.status !== 404) {
            console.log("ERROR", JSON.stringify(error));
          }
        });
    },

    preDeleteTournament () {
      this.modalText = 'Weet u zeker dat u dit toernooi wilt verwijderen?';
      this.showingModal=true;
    },

    setActiveTab (tabItem) {
      this.activeTabItem = tabItem
    },

    showDate: function(sDate) {
      moment.locale(this.$i18n.locale);
      return moment(sDate).format("DD MMM yyyy");
    },
    
    showRoundResults(roundNumber) {
      console.log("showRound Event caught. " + roundNumber);
      this.activeRound = roundNumber;
      this.setActiveTab("Results");
    },

    showTournamentDate() {
      var startDate = this.showDate(this.tournament.startDate);
      var endDate = this.showDate(this.tournament.endDate);
      var returnDate = "";

      if (startDate == "Invalid date") {
        if (endDate == "Invalid date") {
          returnDate = "Onbekend";
        } else
          returnDate = this.$t('tournament.until') + endDate;
      } else {
        if (endDate == "Invalid date") 
          returnDate = startDate;
        else
          returnDate = startDate + " " + this.$t('tournament.until') + " " + endDate;
      }
      
      return returnDate;
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.actions {
  padding: 0vw 0.5vw;
}

.container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.details {
  padding: 1vw;
  font-weight: bold;
}

.details .imgbtn {
  margin-left: 4px;
}

.footer {
  margin-top: 20px;
  text-align: right;
}

/* mobile */
@media screen and (max-width: 600px) {
  .container {
    width: 96vw;
  }
  .modal {
    width: 98vw;
    max-height: 90vh;
    overflow-x: hidden;
    overflow-y: hidden;
  }
}

/* ipad */
@media screen and (min-width: 601px) and (max-width: 1280px) {
  .container {
    width: 96vw;
  }

  .modal {
    width: 50vw;
    max-height: 90vh;
    overflow-x: hidden;
    overflow-y: hidden;
  }
}

/* laptop */
@media screen and (min-width: 1281px) {
  .container {
    width: 50vw;
  }
  .modal {
    width: 50vw;
    max-height: 90vh;
    overflow-x: hidden;
    overflow-y: hidden;
  }
}


</style>
